import { Button, Grid, GridItem, Heading, Text, VStack } from '@chakra-ui/react'
import { toLocalizedEuro } from '@twlvxtwlv/utils/src/localization'
import { useTranslation } from 'next-i18next'
import type { NotifyMeAttributes, ProductAvailability } from '@twlvxtwlv/types'
import NextLink from 'next/link'

interface RoadmapProductsLeftCtaProps {
  currentlyAvailableTokens: number | null
  productIsPurchasable: boolean
  nftId: string | null
  priceInEuroCents: number
  showTokensLeft: boolean
  availability: ProductAvailability | null | undefined
  nftTitle: string | null
  onOpenNotifyMeModal: () => void
  onNotifyMeAttributesChanged: (attributes: NotifyMeAttributes | null) => void
}

export function RoadmapProductsLeftCta({
  currentlyAvailableTokens,
  productIsPurchasable,
  nftId,
  priceInEuroCents,
  showTokensLeft,
  availability,
  nftTitle,
  onOpenNotifyMeModal,
  onNotifyMeAttributesChanged,
}: RoadmapProductsLeftCtaProps) {
  const { t } = useTranslation('nft-details')

  return (
    <VStack pb={4} gap={1}>
      <Grid templateColumns="repeat(2, 1fr)" gap={8} py={2} w="full">
        {showTokensLeft ? (
          <GridItem w="100%">
            <Heading fontSize={['xs', 'xs', 'md']} fontWeight="400" color="txtWhite" pb={1}>
              {t('tokens-left')}
            </Heading>

            <Text fontSize={['sm', 'sm', 'md']}>{currentlyAvailableTokens}</Text>
          </GridItem>
        ) : null}
        {productIsPurchasable ? (
          <GridItem w="100%">
            <Heading fontSize={['xs', 'xs', 'md']} fontWeight="400" color="txtWhite" pb={1}>
              {t('price')}
            </Heading>
            <Text fontSize={['sm', 'sm', 'md']}>{toLocalizedEuro(priceInEuroCents)}</Text>
          </GridItem>
        ) : null}
      </Grid>

      <Button as={NextLink} variant="txtWhite" href={'/nft/' + nftId} passHref>
        {t('road-map-learn-more')}
      </Button>

      {availability !== 'buyable' ? (
        <Button
          onClickCapture={() => {
            onNotifyMeAttributesChanged({ PRODUCT_ID: nftId, PRODUCT_NAME: nftTitle })
            onOpenNotifyMeModal()
          }}
          variant="txtSignalLime"
          onClick={() => {
            onNotifyMeAttributesChanged({ PRODUCT_ID: nftId, PRODUCT_NAME: nftTitle })
            onOpenNotifyMeModal()
          }}
        >
          {t('nft-details:notify-me')}
        </Button>
      ) : (
        <Button as={NextLink} variant="txtSignalLime" href={'/checkout/' + nftId} passHref>
          {t('nft-details:buy-campaign')}
        </Button>
      )}
    </VStack>
  )
}
